(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ring-designer"] && !Shopify.designMode) return;
  try {
    
(function () {
  const metalColours = {
    "yellow-gold": ["#fff2b8", "#c89636", "#6f4511"],
    "yellow-gold-22k": ["#fff1a6", "#d6a51f", "#7a4f00"],
    "yellow-gold-24k": ["#fff07a", "#e2b714", "#825700"],
    "white-gold": ["#ffffff", "#d7d9dc", "#7f848a"],
    "rose-gold": ["#ffd8c9", "#c98268", "#754033"],
    platinum: ["#ffffff", "#d9e2e6", "#77858d"],
    "sterling-silver": ["#ffffff", "#cbd1d5", "#68727a"]
  };
  const stoneColours = {
    colourless: ["#ffffff", "#d9efff", "#7fa4bf"],
    champagne: ["#fff6d8", "#d9b36c", "#7b5422"],
    cognac: ["#ffe4b3", "#b66a2c", "#5c2c12"],
    yellow: ["#fffbd0", "#edcc3e", "#896b05"],
    orange: ["#fff0cf", "#ef8b2c", "#9b3f05"],
    peach: ["#fff1e8", "#f1a07f", "#a04f3e"],
    pink: ["#fff0f4", "#e68dac", "#8d3758"],
    red: ["#ffe8e8", "#d93d4b", "#6f0d1c"],
    purple: ["#f5ebff", "#9b62cc", "#43205f"],
    blue: ["#e7f4ff", "#4f8fd6", "#173f7d"],
    teal: ["#e0fffb", "#2caaa2", "#10524f"],
    green: ["#e8ffe9", "#4cae68", "#15542b"],
    brown: ["#f4e2cf", "#8b5b38", "#3f2414"],
    grey: ["#f6f7f8", "#9aa4ad", "#41484f"],
    black: ["#777d82", "#24282c", "#050607"]
  };

  document.querySelectorAll("[data-ring-designer]").forEach(function (designer) {
    const controls = Array.from(designer.querySelectorAll("[data-ring-option]"));
    const summary = designer.querySelector("[data-ring-summary]");
    const status = designer.querySelector("[data-ring-status]");
    const stone = designer.querySelector("[data-ring-stone]");
    const contact = designer.querySelector("[data-ring-contact]");
    const save = designer.querySelector("[data-ring-save]");

    const selection = function () {
      return controls.reduce(function (result, control) {
        result[control.dataset.ringOption] = {
          value: control.value,
          label: control.options[control.selectedIndex].text
        };
        return result;
      }, {});
    };

    const updatePreview = function () {
      const selected = selection();
      designer.querySelectorAll("[data-cut-shape]").forEach(function (shape) {
        shape.dataset.active = shape.dataset.cutShape === selected.cut.value ? "true" : "false";
      });

      const metal = metalColours[selected.metal.value];
      const stoneColour = stoneColours[selected.colour.value];
      designer.style.setProperty("--metal-light", metal[0]);
      designer.style.setProperty("--metal-mid", metal[1]);
      designer.style.setProperty("--metal-dark", metal[2]);
      designer.style.setProperty("--stone-light", stoneColour[0]);
      designer.style.setProperty("--stone-mid", stoneColour[1]);
      designer.style.setProperty("--stone-dark", stoneColour[2]);
      stone.style.setProperty("--stone-scale", Math.min(1.3, 0.82 + Number(selected.carat.value) * 0.16));

      const text = controls.map(function (control) {
        return control.previousElementSibling.textContent + ": " + control.options[control.selectedIndex].text;
      }).join(" | ");
      summary.textContent = text;
      const destination = new URL(contact.getAttribute("href"), window.location.origin);
      destination.searchParams.set("interest", designer.dataset.interest);
      destination.searchParams.set("design", text);
      contact.setAttribute("href", destination.pathname + destination.search);
      status.textContent = designer.dataset.readyMessage;
    };

    const updateWithTransition = function () {
      if (document.startViewTransition) {
        document.startViewTransition(updatePreview);
      } else {
        updatePreview();
      }
    };

    controls.forEach(function (control) {
      control.addEventListener("change", updateWithTransition);
    });

    save.addEventListener("click", function () {
      const selected = selection();
      try {
        window.localStorage.setItem("aurumvitaRingDesign", JSON.stringify(selected));
        status.textContent = designer.dataset.savedMessage;
      } catch (error) {
        status.textContent = summary.textContent;
      }
    });

    try {
      const saved = JSON.parse(window.localStorage.getItem("aurumvitaRingDesign"));
      if (saved) {
        controls.forEach(function (control) {
          const stored = saved[control.dataset.ringOption];
          if (stored && Array.from(control.options).some(function (option) { return option.value === stored.value; })) {
            control.value = stored.value;
          }
        });
      }
    } catch (error) {
      window.localStorage.removeItem("aurumvitaRingDesign");
    }

    updatePreview();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
